import { connect } from "react-redux";

import ConvertersPannel from "../Components/Converters/ConvertersPannel";
import {
  addConverter,
  addNConverters,
  copyConverter,
  removeConverter,
  setConfigParam,
  setDraggedConverter,
} from "../store/actions/actions";

const mapStateToProps = (state) => {
  return {
    converters: state.converters,
    locale: state.locale,
    draggedConverter: state.draggedConverter,
  };
};

const mapDispatchToProps = {
  addConverter,
  addNConverters,
  copyConverter,
  removeConverter,
  setConfigParam,
  setDraggedConverter,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConvertersPannel);
